import { TemplateRef } from "@angular/core";
import { IDRMLicenseServer } from '@videogular/ngx-videogular/core';
import { Observable } from "rxjs";
import { EUserMode, EUserPermission, eFileUploadCategories, eHome365DisplayFile, eHome365NotesEntities, eNotesVisibility, eNotesWriterTypes } from "./enums";
import { Portal } from "@angular/cdk/portal";

export interface LinkModel extends Link {
    nested?: Link[]
  }
export interface Link {
    url?: string,
    hasUrl?: boolean,
    outerUrl?: string, // will redirect to another site
    name: string,
    icon?: string,
    letter?: string,
    expended?: boolean,
    template?: TemplateRef<Element>,
    templateContext?: Object,
    open?: boolean,
    style?: string,
}

export interface LocationDropDownConfig {
    hideAll: boolean;
    disableDropDown: boolean;
  }
export interface RouteData {
    title: string;
    lockHeight?: boolean;
    showLocationDropDown?: boolean;
    locationDropDownConfig?: LocationDropDownConfig;
    disableDropDown?: boolean;
    banners?: { showOwnerBanner?: boolean };
}

export class chatRecordModel {
  taskId?: string;
  ticketId?: string;
  id?: string;
  message?: string;
  senderId?: string;
  senderName?: string;
  senderImg?: string;
  createdAt?: string;
  deleted?: boolean;
  attachments?: chatRecordAttModel[];
  imagesCarousel?: any;
  direction?: string;
  imageCount?: number;
  pipelineLabel?: string;
}

export class chatRecordAttModel {
  url?: string;
  fileUrl?: string;
  fileName?: string;
}

export interface BoardStatusObject {
  type: string;
  status: string;
  statusClass?: string;
  days: number;
  text?: string;
}

export interface IMediaStream {
  type: 'vod' | 'dash' | 'hls';
  source: string;
  label: string;
  token?: string;
  licenseServers?: IDRMLicenseServer;
}

export type Home365SaveNoteFunc = (note: Home365Note) => Observable<Home365Note>;

export interface Home365Note {
  target?: string;
  date: number;
  entityIdentifier?: string;
  entityType?: eHome365NotesEntities;
  loading?: boolean;
  note: string;
  noteId?: string;
  seen?: boolean;
  user: {
    id: string;
    name?: string;
    img?: string;
  };
  files?: [
      {
        id: string,
        fileUrl: string,
        fileName: string,
        createdOn: string,
        category?: string,
        subCategory?: string,
        entityIdentifier?: string,
        entityType?: string,
        active: boolean
      }
    ];
  writerEntityType?: eNotesWriterTypes;
  myNote?: boolean;
  visibility?: eNotesVisibility;
  imagesCarousel?: any;
}
export class User {
  public permission?: EUserPermission;
  public userMode?: EUserMode;
  userName?: string;
  public profileImageUrl?: string;
  public userId?: string;
  public phone?: string;
  public firstName?: string;
  public lastName?: string;
  public accountName?: string;
  public email?: string;
  public isSucceeded?: boolean;
  // public failureReason?: string;
  public authorization?: string;
  public code?: string;
  public businessType?: number;
  public fromApp?: boolean;
  public appLedger?: boolean
}

export interface ISupportedFileTypeAndSize {
  type: string;
  size: number;
}

export interface EntityFile {
  active: boolean;
  category: eFileUploadCategories;
  createdOn: string;
  entityIdentifier: string;
  entityType: string;
  fileName: string;
  fileUrl: string;
  id: number;
  subCategory: string;
  isFavouriteFile?: boolean;
  isPlaceholder?: boolean;
}

export interface ResultModalData {
  default: {
    response?: any,
    successes?: boolean,
    message?: string | string[]
  },
  showCloseIcon?: boolean, // default true
  displayTimeInSeconds?: number,
  portal?: Portal<any>,
  template?: {template: TemplateRef<any>, context: any},
  errorNote?: string,
  style?: string,
  isCustomStyle?: boolean;
}

export interface Home365DisplayFileModel {
  img?: boolean,
  fileType?: eHome365DisplayFile,
  src: string,
  pdf?: boolean,
  displayName?: string
}

export interface ticketObject {
  address: string;
  assignee: assigneeObject;
  category: string
  description: string;
  disabled: boolean;
  displayStatus: BoardStatusObject;
  id: string;
  lastUpdate: string;
  status: string;
  ticketNumber: number;
  unSeenMessages: number;
}

export interface assigneeObject {
  fullName: string;
  contactId: string;
  profileImg?: string;
}

export interface requestUser {
  email?: string;
  id: string;
  name: string;
  fullName?: string
  phoneData?: any;
  phoneNumber?: string;
  type: string;
  lastName?: string;
  firstName?: string;
}
